var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    fill: "#4285f4",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.735 22.2a6 6 0 0 1 -4.235-10.243l8.485-8.485a1 1 0 0 1 1.415 1.414l-8.489 8.485a4 4 0 0 0 5.657 5.657l10.96-10.96a2.5 2.5 0 0 0 -3.536-3.536l-8.839 8.839a1 1 0 0 0 .708 1.707.986.986 0 0 0 .707-.293l5.657-5.656a1 1 0 1 1 1.414 1.414l-5.657 5.657a3 3 0 0 1 -4.243 0 3 3 0 0 1 0-4.242l8.839-8.839a4.5 4.5 0 0 1 6.364 6.364l-10.96 10.96a5.956 5.956 0 0 1 -4.243 1.757z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.739 21.946a5.746 5.746 0 0 1 -4.065-9.812l8.485-8.486a.75.75 0 1 1 1.061 1.061l-8.486 8.485a4.25 4.25 0 0 0 6.011 6.006l10.96-10.96a2.75 2.75 0 0 0 0-3.89 2.757 2.757 0 0 0 -3.89 0l-8.838 8.844a1.25 1.25 0 0 0 1.768 1.768l5.655-5.656a.75.75 0 1 1 1.061 1.06l-5.656 5.656a2.75 2.75 0 0 1 -3.89-3.888l8.84-8.834a4.25 4.25 0 1 1 6.011 6.011l-10.96 10.96a5.732 5.732 0 0 1 -4.067 1.675z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attach-file.dad6398cfe32d6f49636cb10948336c8.svg";
export { ForwardRef as ReactComponent };